import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface SelectedVaultInfo {
  id: string | number;
  name?: string;
}

@Injectable({
  providedIn: 'root',
})
export class VaultSelectionBroadcastService {
  private selectedVaultSubject = new BehaviorSubject<SelectedVaultInfo | null>(null);

  setSelectedVault(selection: SelectedVaultInfo | null): void {
    this.selectedVaultSubject.next(selection);
  }

  getSelectedVault(): Observable<SelectedVaultInfo | null> {
    return this.selectedVaultSubject.asObservable();
  }

  getSelectedVaultSnapshot(): SelectedVaultInfo | null {
    return this.selectedVaultSubject.value;
  }
  clearSelectedVault(): void {
    this.selectedVaultSubject.next(null);
  }
}

